import styled from '@emotion/styled';

export const StyledTextareaAnnotation = styled.textarea<{ isFocused: boolean }>`
	border: ${props => (props.isFocused ? '1px solid #000' : '0 none')};
	resize: none;
	background: transparent;
	height: 100%;
	width: 100%;
	outline: none;
	overflow: hidden;
	border-radius: 2px;
	margin: ${props => (props.isFocused ? '-1px' : '0')};
	background: ${props => (props.isFocused ? '#ffffff' : 'initial')};
`;

export const StyledDummyTextElement = styled.div`
	font-family: 'Public Sans';
	font-size: 14px;
	position: absolute;
	white-space: pre-wrap;
`;
